<template>
    <div class="animated fadeIn">

        <!-- Splash section -->
        <section class="hero is-medium has-border-bottom-gray">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-vcentered">
                        <div class="column has-padding-top-2x-mobile">
                            <div class="columns is-centered is-vcentered contact-us-header-mailbox is-mobile">
                                <div class="column is-narrow padding-top-2x-mobile">
                                    <figure class="image faq-splash" v-if="!isMobile()">
                                        <img alt="Frequently asked questions" src="./assets/faq-splash.svg">
                                    </figure>
                                    <figure class="image faq-splash mobile-screen" v-else>
                                        <img alt="Frequently asked questions" src="./assets/faq-splash.svg">
                                    </figure>
                                </div>
                            </div>
                            <div class="columns is-centered padding-top-2x">
                                <h1 class="title is-size-2 has-text-centered-mobile uptin-text-center">
                                    {{ $t('faq:faq.title') }}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section" id="TOC">
            <div class="small-container">
                <div class="content is-medium">
                    <div class="has-text-centered">
                        <h2 class="title is-3 is-spaced is-margin-top-small uptin-text-center is-size-4">
                            {{ $t('faq:faq.subtitle') }}
                        </h2>
                    </div>
                    <br/>
                    <ul>
                        <li>
                            <a href="#poc" v-scroll-to="'#poc'">
                                {{ $t('faq:faq.whatis') }}
                            </a>
                        </li>
                        <li>
                            <a href="#application" v-scroll-to="'#application'">
                                {{ $t('faq:faq.application') }}
                            </a>
                        </li>
                        <li>
                            <a href="#howworking" v-scroll-to="'#howworking'">
                                {{ $t('faq:faq.how_working') }}
                            </a>
                        </li>
                        <li>
                            <a href="#howtouse" v-scroll-to="'#howtouse'">
                                {{ $t('faq:faq.how_to_use') }}
                            </a>
                        </li>
                        <li>
                            <a href="#pricingfacts" v-scroll-to="'#pricingfacts'">
                                {{ $t('faq:faq.pricing') }}
                            </a>
                        </li>
                        <li>
                            <a href="#whosuser" v-scroll-to="'#howuser'">
                                {{ $t('faq:faq.how_user') }}
                            </a>
                        </li>
                        <li>
                            <a href="#premiumvsfree" v-scroll-to="'#premiumvsfree'">
                                {{ $t('faq:faq.premium_vs_free') }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="section" id="faq">
            <div class="small-container">
                <div class="content is-medium">
                    <h3 id="poc" class="is-size-5">
                        {{ $t('faq:faq.whatis') }}
                    </h3>
                    <p class="is-size-6 faq-text uptin-text-7">
                        {{ $t('faq:faq.whatis_ans') }}
                    </p>

                    <h3 id="application" class="is-size-5">
                        {{ $t('faq:faq.application') }}
                    </h3>
                    <p class="is-size-6 faq-text uptin-text-7">
                        {{ $t('faq:faq.application_ans') }}
                    </p>

                    <h3 id="howworking" class="is-size-5">
                        {{ $t('faq:faq.how_working') }}
                    </h3>
                    <p class="is-size-6 faq-text uptin-text-7">
                        {{ $t('faq:faq.how_working_ans') }}
                    </p>

                    <h3 id="howtouse" class="is-size-5">
                        {{ $t('faq:faq.how_to_use') }}
                    </h3>
                    <p class="is-size-6 faq-text uptin-text-7">
                        {{ $t('faq:faq.how_to_use_ans') }}
                    </p>

                    <h3 id="pricingfacts" class="is-size-5">
                        {{ $t('faq:faq.pricing') }}
                    </h3>
                    <p class="is-size-6 faq-text uptin-text-7">
                        {{ $t('faq:faq.pricing_ans') }}
                    </p>

                    <h3 id="howuser" class="is-size-5">
                        {{ $t('faq:faq.how_user') }}
                    </h3>
                    <p class="is-size-6 faq-text uptin-text-7">
                        {{ $t('faq:faq.how_user_ans') }}
                    </p>

                    <h3 id="premiumvsfree" class="is-size-5">
                        {{ $t('faq:faq.premium_vs_free') }}
                    </h3>
                    <p class="is-size-6 faq-text uptin-text-7">
                        {{ $t('faq:faq.premium_vs_free_ans') }}
                    </p>

                </div>
            </div>
        </section>
        <section class="hero is-white">
            <div class="hero-body has-text-centered">
                <div class="container">
                    <div class="column has-padding-2x">
                        <div class="columns is-centered is-vcentered">
                            <div class="column uptin-text-center">
                                <h3 class="title is-size-5 uptin-text-center">
                                    {{ $t('faq:faq.more_questions') }}
                                </h3>
                            </div>
                        </div>
                        <div class="columns is-centered is-vcentered">
                            <div class="column uptin-text-center">
                                <router-link to="contact-us" class="button uptin-splash-button is-background-dark3">
                                    {{ $t('faq:faq.send_us_message') }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <download-app></download-app>
        <pay-as-you-go></pay-as-you-go>
    </div>
</template>

<style lang="scss">
    .faq-text {
        text-align: justify;
        text-justify: inter-word;
    }

    .faq-splash {
        max-width: 250px;
        min-width: 250px;
        height: auto;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }

</style>

<script>
    import DownloadApp from "@/components/download-app/download-app"
    import PayAsYouGo from "@/components/pay-as-you-go/pay-as-you-go"

    export default {
        name: 'viral-faq',
        components: {
            PayAsYouGo,
            DownloadApp
        },
        methods: {
            isMobile() {
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
            }
        }
    }
</script>
